import { useGetSortedAndFilteredThreadsWithMetadata } from 'ClientPortal/src/api/Queries/threads'
import { useFormQueryParams } from 'ClientPortal/src/router/useFormQueryParams'
import { useTypedParams } from 'ClientPortal/src/router/useTypedParams'
import { useGetOrderOverview } from 'ClientPortal/src/api/Queries/orders'
import { useGetUsers, usePinThread } from 'ClientPortal/src/api/Queries/users'
import { useCreateNewThread } from 'ClientPortal/src/pages/Orders/OrderDetails/ThreadList/useCreateThread'
import { throwOnForbiddenApiError } from 'ClientPortal/src/api/react-query-config'

export function useThreadListPageData() {
    const { orderId } = useTypedParams(['orderId'])

    const { users } = useGetUsers({ orderId })
    const { orderOverview } = useGetOrderOverview({ throwOnError: throwOnForbiddenApiError })

    const { filteredAndSortedThreads, isThreadsPending, pinnedThreads } = useGetSortedAndFilteredThreadsWithMetadata({
        orderId,
    })

    const { createMode, setCreateMode } = useFormQueryParams()

    const { pinThread, unpinThread, isPatchingUser: isPatchingPin } = usePinThread({ pinnedThreads })

    return {
        threads: filteredAndSortedThreads,
        isThreadsPending,
        createMode,
        setCreateMode,
        orderId,
        users,
        orderOverview,
        ...useCreateNewThread({ orderId }),
        pinThread,
        unpinThread,
        isPatchingPin,
    }
}
